import { LogOut } from "lucide-react";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminSession } from "@/modules/auth/context/sessionContext";

export function SignOutButton({ className = "" }: { className?: string }) {
  const { logout } = useAdminSession();
  const navigate = useNavigate();
  const pending = useRef(false);
  const [busy, setBusy] = useState(false);
  const [failure, setFailure] = useState("");
  const signOut = async () => {
    if (pending.current) return;
    pending.current = true;
    setBusy(true);
    setFailure("");
    try {
      await logout();
      navigate("/login", { replace: true });
    } catch (error) {
      setFailure(`Sign out failed. ${error instanceof Error ? error.message : "Please try again."}`);
    } finally {
      pending.current = false;
      setBusy(false);
    }
  };
  return <>
    <button className={className} onClick={() => void signOut()} disabled={busy} aria-busy={busy} type="button"><LogOut size={16} aria-hidden="true" />{busy ? "Signing out…" : "Sign out"}</button>
    {failure ? <p className="form-error" role="alert">{failure}</p> : null}
  </>;
}
